export default "__VITE_PUBLIC_ASSET__10a8b151__"